import React, { forwardRef } from 'react';
import {
    Dialog,
    DialogContent,
    IconButton,
    AppBar,
    Toolbar,
    Typography,
    Slide,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { TransitionProps } from '@mui/material/transitions';

interface WebviewModalProps {
    open: boolean;
    url: string;
    onClose: () => void;
}

// Explicitly type children instead of using any
const Transition = forwardRef(function Transition(
    props: TransitionProps & { children: React.ReactElement<unknown, string | React.JSXElementConstructor<unknown>> },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const WebviewModal: React.FC<WebviewModalProps> = ({ open, url, onClose }) => {
    return (
        <Dialog open={open} onClose={onClose} fullScreen TransitionComponent={Transition}>
            <AppBar elevation={0} color="default" sx={{ position: 'sticky' }}>
                <Toolbar>
                    <Typography variant="subtitle1" sx={{ flexGrow: 1, fontWeight: 600 }}>
                        Terms & Privacy
                    </Typography>
                    <IconButton edge="end" color="inherit" onClick={onClose} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <DialogContent sx={{ p: 0 }}>
                <iframe
                    src={url}
                    title="Terms and Privacy"
                    width="100%"
                    height="100%"
                    style={{ border: 'none' }}
                />
            </DialogContent>
        </Dialog>
    );
};

export default WebviewModal;
